/** 知识地图相关页面 i18n（zh-CN）— 合并至 knowledgeMap 命名空间 */
export default {
  knowledgeMap: {
    main: {
      title: '知识地图',
      myMaps: '我的知识地图',
      expandSidebar: '展开侧栏',
      collapseSidebar: '折叠侧栏',
      statTopics: '主题',
      statNodes: '知识点',
      statPinned: '置顶',
      searchTopics: '搜索主题...',
      newTopic: '新建主题',
      batchMode: '批量操作',
      mergeTopics: '合并主题',
      exportSelected: '导出所选',
      batchSmartHeal: '批量智能自愈',
      batchSmartHealAll: '全主题智能自愈',
      deleteSelected: '删除所选',
      sortRecent: '按最近更新',
      sortNodeCount: '按知识点数量',
      sortName: '按名称字母',
      noTopics: '暂无主题',
      noMatchingTopics: '没有匹配的主题或已加载内容',
      topicsLoadFailed: '主题列表加载失败',
      retry: '重试',
      dataSubscriptionDenied: '暂无数据订阅权限',
      dataSubscriptionFeedDenied: '暂无订阅更新查看权限',
      unpin: '取消置顶',
      pin: '置顶',
      rename: '重命名',
      subscribeUpdates: '订阅更新',
      subscribeConfig: '订阅配置',
      delete: '删除',
      emptyMain: '暂无内容，在调研中选中有价值的内容，点击添加到知识地图快速开始构建你的专属知识地图吧',
      createFirstTopic: '创建第一个主题',
      pinnedTag: '已置顶',
      materialsCount: '{count} 条素材',
      categoriesCount: '{count} 个分类',
      updatedAgo: '{time}更新',
      viewUpdates: '查看更新',
      viewMindmap: '脑图',
      viewOutline: '大纲',
      viewGraph: '知识图谱',
      wikiMaintained: 'AI 维护',
      wikiOverview: '主题 Wiki 总览',
      wikiDesc: '系统会把零散素材整理成可追溯、可复用的一页式主题认知。',
      wikiStatus: '整理状态',
      lifecycle: '生命周期',
      materialCount: '素材数',
      wikiUpdated: 'Wiki 更新',
      version: '版本',
      wikiGenerating: 'Wiki 正在后台整理中，页面会自动刷新状态。',
      wikiGeneratingTip: '通常需要几十秒，请保持当前页打开。',
      wikiFailed: '上次整理失败，已保留兜底 Wiki：{error}',
      sourceBreakdown: '来源构成',
      noSourceStats: '暂无可统计素材来源',
      recentMaterials: '最近素材',
      noRecentMaterials: '暂无最近素材',
      subscriptionPreview: '订阅预览',
      toc: '页面目录',
      copy: '复制',
      exportPackage: '主题包',
      regenerating: '整理中',
      regenerate: '重新整理',
      smartHeal: '智能自愈',
      healthCheck: '一键体检',
      archiveWiki: '归档 Wiki',
      restoreWiki: '还原 Wiki',
      semanticDiscuss: '语义研讨',
      editSection: '编辑此节',
      searchNodes: '搜索知识点内容...',
      expandAll: '全部展开',
      collapseAll: '全部折叠',
      copyAll: '复制全部内容',
      noMatchingNodes: '没有匹配的知识点',
      noNodes: '该主题下暂无知识点',
      addNode: '新增知识点',
      editMdPlaceholder: '输入 Markdown 内容...',
      dblClickEdit: '双击快速编辑',
      edit: '编辑',
      copyContent: '复制内容',
      searchGraphNodes: '搜索节点（回车定位）',
      zoomIn: '放大',
      zoomOut: '缩小',
      fitScreen: '适应屏幕',
      exportPng: '导出 PNG',
      exitFullscreen: '退出全屏',
      fullscreen: '全屏',
      searchNodesShort: '搜索节点…',
      toggleLabels: '显示/隐藏标签',
      lightTheme: '切换浅色',
      cosmicTheme: '切换星空主题',
      disableFocus: '关闭邻域聚焦',
      enableFocus: '开启邻域聚焦',
      fitCanvas: '适应画布',
      fullscreenExplore: '全屏探索',
      copyName: '复制名称',
      archived: '已建档',
      notArchived: '未建档',
      chars: '{count} 字',
      editSectionTitle: '编辑章节: {title}',
      editIntroSection: '编辑导言章节',
      sectionTitle: '章节标题',
      sectionTitlePlaceholder: '请输入章节标题',
      sectionContent: '章节内容 (支持 Markdown)',
      sectionContentPlaceholder: '请输入章节内容...',
      newTopicDialog: '新建主题',
      topicName: '主题名称',
      topicNamePlaceholder: '请输入主题名称',
      newCategory: '新建分类',
      categoryName: '分类名称',
      categoryNamePlaceholder: '例如：作用机制 / 临床进展',
      addKnowledgeNode: '新增知识点',
      targetCategory: '目标分类',
      uncategorized: '不选择则放入未分类',
      nodeContent: '知识点内容（支持 Markdown）',
      nodeContentPlaceholder: '**关键概念**：在此输入要点描述...',
      livePreview: '实时预览',
      batchMoveNodes: '批量移动知识点',
      moveNode: '移动知识点',
      targetTopic: '目标主题',
      moveCategory: '移动分类',
      wikiDiscuss: '💬 主题 Wiki 语义学术研讨',
      unnamedMaterial: '未命名素材',
      noSnippet: '暂无片段',
      wikiAskPlaceholder: '问问 Wiki... 比如「该靶点有哪些突出的临床关联与安全限制？」',
      healthDiagnosis: '🔍 主题知识图谱一键体检诊断',
      materialDetail: '素材详情',
      sortRecentLabel: '最近更新',
      sortNodeCountLabel: '知识点数',
      sortNameLabel: '名称',
      sortLabel: '排序',
      noSummary: '暂无内容摘要',
      locatedInOutline: '已定位到大纲中的素材',
      lifecycleDraft: '草稿',
      lifecycleActive: '活跃',
      lifecycleStale: '待更新',
      lifecycleContradicted: '争议矛盾',
      lifecycleArchived: '已归档',
      wikiStatusGenerating: '整理中',
      wikiStatusReady: '已生成',
      wikiStatusFallback: '有兜底',
      wikiStatusPending: '待整理',
      sourceTargetAnalysis: '靶点分析',
      sourceTargetChat: '报告问答',
      sourceTargetReport: '靶点报告',
      sourceReport: '靶点报告',
      sourceChat: '聊天',
      sourceEncyclopedia: '智能百科',
      depthAll: '全展开',
      depthLayers: '{n} 层',
      nodeTypeSynthesis: '智能合成成果',
      nodeTypeEntity: '百科实体知识',
      nodeTypeConcept: '概念实体',
      nodeTypeSource: '原始导入文献',
      nodeTypePhantom: '未定义幻影节点',
      subscribe: '订阅',
      nodeDetail: '知识点详情',
      close: '关闭',
      preview: '预览',
      dragSort: '拖拽排序',
      outlineNav: '大纲导航',
      noTopicSelected: '未选择主题',
      outlineMeta: '共 {categories} 个一级标题 · {nodes} 个知识点',
      emptyOutline: '当前主题暂无大纲内容',
      nodesInCategory: '{count} 个知识点',
      outlinePointTitle: '{category}要点 {index}',
      viewWiki: 'Wiki',
      wikiAccessDeniedTier: '当前会员等级未开放 LLM Wiki 与知识图谱；脑图与大纲仍可正常使用',
      wikiAccessDeniedMenu: '未分配 LLM Wiki 菜单权限；仍可添加素材并在脑图/大纲中管理',
      wikiAccessLocked: 'Wiki 增值未开通',
      wikiOptInLabel: 'LLM Wiki',
      wikiOptInDesc: '开启后显示 Wiki 与知识图谱（基于双链拓扑），自动整理主题并按量消耗 X-Coin',
      wikiOptInTitle: '开启 LLM Wiki',
      wikiOptInConfirm: 'LLM Wiki 与知识图谱为按量计费功能。开启后，添加素材时将自动触发主题 Wiki 整理，并显示 Wiki、知识图谱及相关操作。确认开启？',
      wikiOptInConfirmBtn: '确认开启',
      wikiOptInEnabled: '已开启 LLM Wiki',
      wikiOptInDisabled: '已关闭 LLM Wiki',
      wikiOptInOffHint: 'LLM Wiki 默认关闭，请在顶部开关开启后再使用',
      msgNodeAdded: '已添加至知识地图',
      msgAddToMapSuccess: '成功添加至知识地图',
      msgAddToMapSuccessWikiPending: '成功添加至知识地图，Wiki 总览将在后台更新',
      addToMapDialogTitle: '添加至知识地图',
      addToMapSubmit: '添加到知识地图',
      addToMapAndWikiSubmit: '添加并整理 Wiki',
      addToMapContentPreview: '内容预览',
      addToMapContentPlaceholder: '可编辑 / 精简内容，支持 Markdown',
      addToMapKnowledgeTitle: '知识点标题',
      addToMapTitlePlaceholder: '可选，点击「自动分类」可智能推荐',
      addToMapClassifySettings: '归类设置',
      addToMapClassifySubtitle: '可手动选择，或输入后点「创建」',
      addToMapAnalyzing: '分析中...',
      addToMapAutoClassify: '自动分类',
      addToMapRelatedTopic: '关联主题',
      addToMapRelatedCategory: '关联分类',
      addToMapTopDirectory: '一级目录',
      addToMapSelectOrCreate: '选择或新建',
      addToMapInfoBase: '将保存为知识地图素材，可在脑图与大纲中查看、编辑与管理',
      addToMapInfoSeparator: '。',
      addToMapInfoWiki: '保存后将在后台更新该主题的 LLM Wiki 总览',
      addToMapInfoMapOnly: '不含 LLM Wiki 与知识图谱增值能力（不影响脑图与大纲）',
      addToMapInfoOptInOff: '本次仅保存素材；在知识地图顶部开启 LLM Wiki 后可触发自动整理',
      optional: '可选',
      createOption: '创建「{name}」',
      directoryTarget: '靶点',
      directoryDisease: '疾病',
      directoryTechnologyMethod: '技术方法',
      directoryDrug: '药物',
      directoryMechanismPathway: '机制通路',
      directoryPaperReading: '论文精读',
      directoryExperimentMethod: '实验方法',
      directoryOther: '其他',
      categoryGeneralContent: '综合内容',
      operationFailedRetry: '操作失败，请稍后重试',
      msgFillContentBeforeAutoClassify: '请先填写内容后再进行自动分类',
      msgAutoClassifyComplete: '自动分类完成，已填充推荐项',
      msgSmartExtractUnavailableUseSummary: '智能分析不可用，已使用内容摘要作为主题',
      msgLoadTopicsFailed: '获取知识地图主题失败',
      msgLoadTopicCategoriesFailed: '获取主题分类失败',
      msgContentRequired: '内容不能为空',
      msgSelectOrEnterTopic: '请选择或输入关联主题',
      msgAddToMapFailed: '添加至知识地图失败',
      wikiUpgradeHint: '点击前往充值中心升级',
      cancel: '取消',
      save: '保存',
      confirm: '确定',
      create: '创建',
      addMaterial: '新增素材',
      organizeWiki: '整理 Wiki',
      exportMarkdown: 'Markdown',
      outlineHitCount: '命中 {count} 条',
      moveNodesCount: '移动知识点({count})',
      moveCategoriesCount: '移动分类({count})',
      subscribed: '已订阅',
      moveTo: '移动到...',
      unsubscribe: '关闭订阅',
      deleteCategory: '删除分类',
      editContent: '编辑内容',
      refresh: '刷新',
      graphStatSummary: '{visible}/{total} 节点 · {edges} 边',
      graphUndefinedSummary: '未定义节点 {count} 个',
      graphIsolatedSummary: '孤立节点 {count} 个',
      graphAvgEdgeWeightSummary: '平均共现强度 {value}',
      graphAvgRelationPuritySummary: '关系纯度均值 {value}',
      graphLowPuritySummary: '低纯度边 {count} 条',
      graphMinEdgeWeight: '最小边权',
      graphMinRelationPurity: '最小关系纯度',
      graphWeightPresetP50: 'P50',
      graphWeightPresetP75: 'P75',
      graphWeightPresetP90: 'P90',
      graphRelationSummaryTag: '{relation} 强度 {weight}',
      graphRelationSummaryTooltip: '{count} 条边 · 共现强度 {weight}',
      graphRelationChipStat: '{relation} · {count}边/{weight}强度',
      graphTooltipRelationPurity: '关系纯度: {value}%',
      graphQualityScoreSummary: '质量 {value}',
      graphEvidenceCoverageSummary: '证据覆盖 {value}%',
      graphEdgeStrength: '强度 {count}',
      graphEdgeEvidenceCount: '证据片段',
      graphEdgeDirectionPurity: '方向一致性',
      graphEdgeDirectionMix: '方向构成',
      graphEdgeEvidence: '关系证据',
      graphNoEdgeEvidence: '暂无可展示的证据片段。',
      graphEdgeDetailHint: '单击节点切换 · Esc 关闭',
      healBrokenLinks: '自愈死链',
      resetFilters: '重置筛选',
      showUndefinedOnly: '仅看未定义',
      showAllNodeTypes: '显示全部类型',
      community: '社区 #{n}',
      directNeighbors: '直接关联',
      materialStatus: '素材状态',
      networkConnectivity: '网络连接度',
      relatedEntities: '关联实体 · {count}',
      relationDistribution: '关系分布',
      noDirectNeighbors: '暂无直接关联，可刷新拓扑或补充 [[双链]] 引用。',
      locateInOutline: '在大纲中定位',
      locateInWiki: '在 Wiki 中定位',
      tryHealBrokenLinks: '尝试自愈死链',
      graphDetailHint: 'Esc 关闭 · 双击节点聚焦',
      graphLegendTip: '点击图例过滤 · 拖拽节点 · 滚轮缩放',
      locateOutline: '定位到大纲',
      previous: '上一个',
      next: '下一个',
      layout: '布局',
      layoutHorizontal: '水平',
      layoutVertical: '垂直',
      layoutRadial: '放射',
      depth: '深度',
      depthMarkAll: '全',
      mindmapEmptyTitle: '当前主题暂无可展示的素材节点',
      mindmapEmptyTip: '请在大纲视图中添加知识点，或切换其他主题',
      legendTopic: '主题',
      legendCategory: '分类',
      legendNode: '知识点',
      mindmapLegendTip: '提示：滚轮缩放，拖拽平移，点击知识点可跳到素材',
      graphEmptyFiltered: '当前筛选下没有可展示的节点',
      askWikiEmptyTitle: '输入问题，在当前知识图谱星网中展开语义研讨',
      askWikiEmptyTip: '点击 AI 回复底部的「归档学术成果」可直接生成 permanent 节点',
      referenceSources: '参考来源',
      relevance: '相关度 {score}',
      archiveSynthesis: '固化归档为学术成果 (Synthesis)',
      send: '发送',
      ctrlEnterHint: '按 Ctrl + Enter 快捷发送',
      lintConfigTitle: '诊断配置项',
      lintStart: '开始一键体检',
      deepLintTitle: '深度大模型语义审计 (Deep Semantic Audit)',
      deepLintDesc: '开启后，将调用高级大模型执行跨文献 Claims 数据矛盾、陈旧性与盲区诊断。',
      deepLintCostWarning: '深度体检需要调用大模型，单次诊断将消耗约 3~5 X-Coin 虚拟额度。',
      lintNoReport: '暂无诊断报告',
      lintNoReportTip: '点击上方「开始一键体检」按钮，扫描图谱结构健康度',
      lintRunning: '正在执行图谱深度体检...',
      lintRunningTip: '正在扫描死链、孤立文献、缺失核心概念及语义冲突',
      lintStructuralReport: '📊 知识图谱结构化健康度报告',
      lintNodesScanned: '扫描节点总数',
      lintBrokenLinks: '死链 (Broken Links)',
      lintOrphans: '孤立文献素材 ({count})',
      lintOrphansTip: '这些文献完全没有被任何双链 [[Link]] 引用，处于孤立状态，建议在 Wiki 整理时建立关联。',
      lintNoOrphans: '🎉 图谱无孤立文献，关联度良好！',
      lintMissingEntities: '高频提及但尚未建立实体的概念 ({count})',
      lintMissingEntitiesTip: '在多篇文献中被高频引用，但尚未在系统中创建正式的百科实体卡片。建议点击「智能自愈」批量合成。',
      lintMentionCount: '提及 {count} 次',
      lintOneClickSynthesis: '一键合成',
      lintAllEntitiesCreated: '🎉 所有被提及的关键学术概念均已建立实体卡片！',
      lintSemanticReport: '🧠 深度大模型语义冲突与漏洞体检报告',
      sourceLlmWiki: 'LLM Wiki',
      sourceConcept: '智能概念',
      sourceSynthesis: '智能成果',
      sourceManual: '手动添加',
      sourceUnknown: '未知',
      nodeTypeSynthesisShort: '合成',
      nodeTypeEntityShort: '实体',
      nodeTypeConceptShort: '概念',
      nodeTypeSourceShort: '文献',
      nodeTypePhantomShort: '幻影',
      wikiEmptyRunning: 'Wiki 正在后台整理中',
      wikiEmptyNoContent: 'Wiki 总览已创建但正文暂为空',
      wikiEmptyNotGenerated: '该主题暂未生成 Wiki 总览',
      wikiEmptyTipRunning: '页面会自动刷新整理结果，也可以稍后回来查看。',
      wikiEmptyTipNoContent: '可点击重新整理生成正文，或先新增素材后再整理。',
      wikiEmptyTipDefault: '新增或收藏一条素材后，系统会在后台自动维护主题 Wiki。',
      entityTypeConcept: '概念词条',
      entityTypeEntity: '实体词条',
      entityIndexPlaceholder: '该智能百科{type}已建立索引，正文仍在智能自愈生成中。可通过图谱自愈或手动编辑继续补充完整百科内容。',
      synthesisEmptyPlaceholder: '该智能成果节点暂无正文，可通过手动编辑补充内容。',
      unnamedNode: '未命名节点',
      unnamedKnowledgePoint: '未命名知识点',
      unnamed: '未命名',
      unknown: '未知',
      unclassified: '未分类',
      unclassifiedNodes: '未分类知识点',
      exportWikiOverview: 'LLM Wiki 总览',
      exportCategoryMaterials: '分类素材',
      exportMaterialItem: '素材 {index}',
      exportSourceLabel: '来源：',
      exportTimeLabel: '时间：',
      graphTooltipType: '类型：',
      graphTooltipCategory: '分类：',
      graphTooltipNeighbors: '关联：{count} 个节点',
      graphTooltipHint: '单击详情 · 双击聚焦',
      graphTooltipEdge: '星链：{source} → {target}（{relation}）',
      graphTooltipWeight: '共现强度：{count}',
      graphTooltipRelationMix: '关系构成：{mix}',
      graphRelationWikilink: '双链引用',
      graphRelationMentions: '总览提及',
      graphRelationSourceOverlap: '来源重叠',
      graphRelationRelated: '关联',
      graphColorModeType: '按类型着色',
      graphColorModeCommunity: '按社区着色',
      graphInsightsTitle: '图谱洞察',
      graphInsightSurprising: '惊奇连接',
      graphInsightGaps: '知识空白',
      graphInsightCohesion: '内聚度 {value}',
      graphInsightHighlight: '高亮',
      graphTooltipRelevance: '关联度：{score}',
      graphTooltipLinkCount: '双链次数：{count}',
      graphInsightHeal: '智能自愈',
      graphClearHighlight: '清除高亮',
      graphInsightLintMerged: '已合并体检结果',
      graphInsightLintLoading: '正在同步体检数据…',
      graphInsightLintFailed: '洞察体检数据加载失败，图谱仍可正常使用',
      graphInsightBrokenLinks: '死链 {count} 处',
      graphInsightBrokenLinksTip: '存在未建节点的双链引用，建议执行智能自愈。',
      graphInsightMissingEntities: '缺失实体 {count} 个',
      graphInsightMissingEntitiesTip: '高频提及概念尚未建立实体卡片。',
      graphInsightLintOrphans: '孤立素材 {count} 篇',
      graphInsightSparseNodes: '稀疏关联 {count} 篇',
      graphInsightSparseNodesTip: '出链较少，建议补充双链或关联素材。',
      graphInsightAllGood: '当前图谱结构良好，暂无显著空白或异常连接。',
      recallPathDirect: '直接召回',
      recallPathGraph1: '图谱 1-hop',
      recallPathGraph2: '图谱 2-hop',
      msgAskWikiSourceLocated: '已定位参考素材：{title}',
      graphNeighborRelevance: '关联度 {score}',
      graphRelevanceSignals: '关联信号',
      graphEdgeStrong: '强关联',
      graphEdgeWeak: '弱关联',
      msgOperationFailed: '操作失败，请稍后重试',
      msgLoadTopicDetailFailed: '加载主题详情失败',
      msgWikiMarkdownExported: 'Wiki Markdown 已导出',
      msgExportWikiFailed: '导出 Wiki 失败',
      msgTopicMarkdownExported: '主题 Markdown 已导出',
      msgExportTopicFailed: '导出主题失败',
      msgCopiedToClipboard: '已复制到剪贴板',
      msgCopyFailed: '复制失败',
      msgWikiRegenerated: 'Wiki 已重新整理完成',
      msgWikiRegenerateFailed: 'Wiki 整理失败，已保留当前内容{reason}',
      msgWikiStillRunning: 'Wiki 仍在后台整理，可稍后点击刷新查看结果',
      msgNoMaterialsForWiki: '该主题暂无素材，无法整理 Wiki',
      msgWikiRegenerateSubmitted: '已提交重新整理，正在跟踪后台结果',
      msgWikiRegenerateSubmitFailed: '提交重新整理失败',
      msgCategoryUnsubscribed: '已关闭该分类订阅',
      msgUnsubscribeFailed: '关闭订阅失败',
      msgFitScreenDone: '已适应屏幕',
      msgNoMatchingNode: '未找到匹配节点',
      msgMindmapLocated: '已定位 {index}/{total}：{path}',
      msgOutlineCardNotFound: '已切换到大纲，但暂未找到对应卡片',
      msgExportSuccess: '导出成功',
      msgExportFailed: '导出失败',
      msgFullscreenFailed: '全屏切换失败',
      msgCreateSuccess: '创建成功',
      msgCreateFailed: '创建失败',
      msgTopicNameRequired: '主题名称不能为空',
      msgMergePrompt: '合并后这些主题将被删除，其内容会迁移到保留的主题下。请确认保留的主题名称：',
      msgMergeConfirm: '合并',
      msgNameRequired: '名称不能为空',
      msgMergeSuccess: '合并成功',
      msgBatchDeleteConfirm: '确定要删除选中的主题及其所有知识点吗？此操作不可逆。',
      msgBatchDeleteTitle: '批量删除',
      msgBatchDeleteSuccess: '批量删除成功',
      msgBatchHealConfirm: '确认对选中的 {count} 个主题触发智能自愈后台任务？',
      msgBatchHealAllConfirm: '确认对当前账户下全部主题触发智能自愈后台任务？',
      msgBatchHealTitle: '批量智能自愈',
      msgBatchHealSubmitted: '批量自愈任务已提交：入队 {queued}，跳过 {skipped}，失败 {failed}',
      msgBatchHealFailed: '批量智能自愈提交失败',
      msgDeleteTopicConfirm: '是否同时删除该主题下的所有知识点？确认后不可撤销。',
      msgDeleteTopicTitle: '删除主题',
      msgDeleteAll: '删除所有',
      msgDeleteSuccess: '删除成功',
      msgNodeContentRequired: '知识点内容不能为空',
      msgSaved: '已保存',
      msgSaveFailed: '保存失败',
      msgSectionUpdated: '章节已更新',
      msgSaveSectionFailed: '保存章节失败',
      msgPinned: '已置顶',
      msgUnpinned: '已取消置顶',
      msgMovedToCategory: '已成功移动至新分类',
      msgMoveNodeFailed: '移动知识点失败',
      msgSelectNodeForFocus: '请先选择一个节点以聚焦其邻域',
      msgKeepOneNodeType: '请至少保留一种节点类型',
      msgKeepOneRelationType: '请至少保留一种关系类型',
      msgDeleteNodeConfirm: '确定删除该知识点？此操作不可逆。',
      msgDeleteNodeTitle: '删除知识点',
      msgDeleteFailed: '删除失败',
      msgRenamed: '已重命名',
      msgDeleteCategoryWithNodesChoose: '该分类下还有 {count} 个知识点，请选择处理方式：',
      msgDeleteCategoryConfirm: '确定删除该分类？',
      msgDeleteCategoryTitle: '删除分类',
      msgDeleteCategoryAndNodes: '一并删除知识点',
      msgDeleteCategoryOnly: '仅删分类（转未分类）',
      msgCategoryAndNodesDeleted: '已删除分类及知识点',
      msgCategoryDeletedNodesMoved: '已删除分类，节点已转入未分类',
      msgCategoryNameRequired: '请输入分类名称',
      msgSelectTopicFirst: '请先选择主题',
      msgEnterNodeContent: '请输入知识点内容',
      msgNodeAddedWikiPending: '已添加，Wiki 将在后台整理',
      msgAddFailed: '添加失败',
      msgMoveSuccess: '移动成功',
      msgMoveSuccessInTopic: '移动成功，可在「{name}」中查看',
      msgMoveFailed: '移动失败',
      msgSelectNodesAndTopic: '请选择要移动的知识点和目标主题',
      msgSelectCategoryAndTopic: '请选择要移动的分类和目标主题',
      msgCategoryMoveSuccess: '分类移动成功，可在「{name}」中查看',
      msgMoveCategoryFailed: '移动分类失败',
      msgNodeNameCopied: '已复制节点名称',
      msgCopyManual: '复制失败，请手动复制',
      msgNoGraphMatch: '没有匹配的节点',
      msgNoMaterialCard: '该节点暂无对应素材卡片',
      msgGraphNodeNotInOutline: '该图谱节点暂未加载到大纲详情中',
      msgLocated: '已定位：{name}',
      msgFetchTopologyFailed: '获取拓扑数据失败',
      msgHealTaskStarted: '自愈任务已启动，正在刷新主题状态',
      msgHealTriggerFailed: '触发自愈失败',
      msgArchiveWikiConfirm: '归档后 Wiki 页面生命周期将变更为「已归档」，确定归档吗？',
      msgWikiArchived: 'Wiki 已归档',
      msgArchiveFailed: '归档失败',
      msgWikiRestored: 'Wiki 已还原为活跃状态',
      msgRestoreFailed: '还原失败',
      msgNoAnswer: '无回答',
      msgAskWikiFailed: '研讨失败：{detail}',
      msgSynthesisTitlePrompt: '请输入该固化学术成果的标题：',
      msgSynthesisArchiveTitle: '固化归档学术成果',
      msgConfirmArchive: '确定归档',
      msgSynthesisDefaultTitle: '学术研讨: {preview}...',
      msgTitleRequired: '标题不能为空',
      msgSynthesisArchived: '学术研讨已成功固化并归档为一期 Synthesis 学术成果节点！',
      msgArchiveSynthesisFailed: '固化归档失败',
      msgLintSuccess: '一键图谱体检诊断成功完成！',
      msgLintFailed: '图谱体检诊断失败',
      msgOrphanNotFound: '未找到文献卡片：{title}',
      msgOrphanLocated: '已定位文献：{title}',
      msgEntityLocated: '已定位关联实体：[[{name}]]',
      msgGraphEntityLocated: '已自动切换至图谱并定位实体：[[{name}]]',
      msgWikiEntityLocated: '已在 Wiki 中定位实体：[[{name}]]',
      msgWikiLinkNotFound: '在 Wiki 正文中未找到 [[{name}]] 的双链引用',
      msgEntityNotIndexed: '[[{name}]] 暂未建档，可在知识图谱中查看死链或触发智能自愈。',
      msgEntityMultipleMatches: '[[{name}]] 匹配到多个节点，请使用更精确的双链名称。'
    },
    subscription: {
      back: '返回知识地图',
      title: '知识地图订阅配置',
      subtitle: '按主题一级分类关键词，定期检索文献、专利、临床与网络更新，并推送到通知中心',
      typeTag: '知识地图',
      viewFeed: '查看更新',
      typeHint: '订阅类型说明',
      hintMap: '知识地图订阅：基于主题与一级分类关键词，采集外部情报并支持加入脑图 / Wiki 整理。',
      hintReport: '报告内容更新订阅：在靶点报告任务中配置，除外部情报外还包含报告生成流水线日志，请前往任务详情 → 情报订阅。',
      planSection: '采集计划',
      scopeCategory: '单个分类',
      scopeTopic: '整个主题',
      enable: '启用订阅',
      patrolOn: '巡检已开启',
      patrolOff: '巡检已关闭',
      interval: '巡检周期',
      preset: '快捷',
      preset1d: '1 天',
      preset7d: '7 天',
      preset30d: '30 天',
      scopeNote: '当前为分类级订阅；主题级请从脑图页顶部进入',
      dimensions: '采集维度',
      dimAll: '全部',
      dimLiterature: '文献',
      dimPatent: '专利',
      dimClinical: '临床试验',
      dimNews: '网络资讯',
      pipelineNote: '知识地图订阅不包含「报告流水线」维度，该维度仅在报告情报订阅中可用',
      keywords: '检索关键词（一级分类）',
      customKeywords: '当前为自定义关键词，修改后请保存',
      previewSearch: '试检索预览',
      restoreAuto: '恢复自动生成',
      trySearch: '试检索',
      keywordPlaceholder: '输入该分类的检索关键词',
      autoKeywordHint: '保存后将根据主题一级分类自动生成检索关键词',
      notifyChannels: '通知渠道',
      notifyCenter: '通知中心',
      email: '邮件',
      emailPlaceholder: '留空则使用账号邮箱',
      feishuWebhook: '飞书 Webhook',
      keepExisting: '保持现有',
      updateUrl: '更新地址',
      clear: '清除',
      feishuApp: '飞书应用消息',
      feishuInternalOnly: '仅 xtalpi.com 内部用户可用',
      unsaved: '有未保存的更改',
      synced: '配置已同步',
      save: '保存配置',
      collectNow: '立即采集',
      testNotify: '测试通知',
      lastCollect: '上次采集',
      refresh: '刷新',
      nextPlan: '下次计划',
      subscriptionScope: '订阅范围',
      previewRunning: '试检索后台运行中：{query}',
      keywordSearchFallback: '关键词检索',
      viewProgress: '查看进度',
      previewDialogTitle: '试检索预览',
      keywordColon: '关键词：',
      previewSanitized: '已自动精简检索词：{query}',
      previewBgHint: '试检索已在后台执行，通常需 30 秒～3 分钟，可关闭弹窗继续配置',
      previewNoResults: '未检索到相关结果，可缩短关键词或调整采集维度后重试',
      runInBackground: '后台运行',
      intervalAbout1Day: '约 1 天',
      intervalAboutDays: '约 {days} 天',
      intervalAbout1Hour: '约 1 小时',
      intervalAboutHours: '约 {hours} 小时',
      intervalAboutMinutes: '约 {minutes} 分钟',
      customKeyword: '自定义',
      categoryFallback: '分类',
      previewFailed: '试检索失败',
      previewDoneWithTotal: '试检索完成，共 {total} 条',
      previewDoneNoHits: '试检索完成，未命中结果',
      previewStillRunning: '试检索仍在后台执行，请稍后点击「查看进度」重试',
      keywordMinLength: '关键词至少 2 个字符',
      previewTaskFailed: '试检索任务提交失败',
      previewSubmitFailed: '试检索提交失败',
      loadKeywordsFirst: '请先保存或加载关键词',
      keywordsAutoRestored: '已恢复为自动生成的关键词',
      restoreFailed: '恢复失败',
      invalidTopic: '主题无效，请从知识地图重新进入',
      loadConfigFailed: '加载订阅配置失败',
      enabledFirstCollect: '订阅已启用，首次采集已在后台执行',
      confirmGoFeedTitle: '首次采集',
      confirmGoFeedMessage: '是否前往订阅更新页查看采集进度？',
      stayOnPage: '留在此页',
      configSaved: '订阅配置已保存',
      saveFailed: '保存失败',
      statusQueued: '排队中',
      statusRunning: '运行中',
      statusSucceeded: '成功',
      statusPartialFailed: '部分失败',
      statusFailed: '失败',
      statusSkipped: '已跳过',
      saveBeforeCollect: '请先保存配置再执行采集',
      collectQueueFailed: '采集任务入队失败',
      collectInProgress: '采集任务执行中，请稍候…',
      collectFailed: '采集失败（{status}）',
      collectDone: '采集完成（{status}），可前往查看更新',
      collectDoneTitle: '采集完成',
      confirmGoFeedAfterCollect: '是否立即前往订阅更新页查看结果？',
      collectBgRunning: '采集仍在后台执行，请稍后在「查看更新」中查看',
      collectSubmitted: '采集任务已提交',
      triggerCollectFailed: '触发采集失败',
      testNotifySent: '测试通知已发送',
      testNotifyPartial: '部分渠道未成功，请检查配置',
      testNotifyFailed: '测试通知失败',
      hintMapLabel: '知识地图订阅',
      hintReportLabel: '报告内容更新订阅',
      feishuWebhookPlaceholder: 'https://open.feishu.cn/open-apis/bot/v2/hook/...',
      feedTitle: '知识地图订阅更新',
      emptyNoRuns: '暂无采集记录',
      emptyNoRunsDesc: '启用订阅后将自动执行首次采集；也可在配置页点击「立即采集」',
      goToConfig: '前往订阅配置',
      feedStreamTitle: '采集结果流',
      feedStreamDesc: '按时间展示自动巡检命中条目，可批量勾选后添加到知识地图；已开通 LLM Wiki 时可触发 Wiki 整理',
      batchCount: '共 {total} 批',
      notified: '已推送',
      hitCount: '命中 {count} 条',
      refRelevance: '相关度 {score}',
      sourceDistribution: '来源分布',
      selectAllBatch: '全选本批',
      llmExtractAdd: 'LLM 智能归类后添加',
      llmExtractTip: '入库前由 LLM 推荐标题与分类，按用量扣 XCoin；不触发 Wiki 整理。需整理 Wiki 请用「抽取并整理 Wiki」（需 LLM Wiki 权限）',
      addToKnowledgeMap: '添加到知识地图',
      extractAndWiki: '抽取并整理 Wiki',
      seenBefore: '历史已见',
      addedToMap: '已加入地图',
      loadMore: '加载更多',
      loadFailed: '加载失败',
      loadMoreFailed: '加载更多失败',
      selectItemsFirst: '请先选择要添加的条目',
      addedCount: '已添加 {count} 条到知识地图',
      wikiTriggered: '，Wiki 整理已触发',
      addFailed: '添加失败',
      wikiFeatureLockedHint: '「抽取并整理 Wiki」需 Plus 及以上并分配 LLM Wiki 权限；「添加到知识地图」仍可保存素材至脑图与大纲。',
      wikiOptInFeedHint: 'LLM Wiki 默认关闭。仍可使用「添加到知识地图」；如需 Wiki 整理，请先在知识地图顶部开启开关。'
    }
  }
}
